export enum ALLOWED_PAYMENT_METHODS {
  CREDIT_DEBIT_CARDS = 'CREDIT_DEBIT_CARDS',
  MOBILE_WALLET = 'MOBILE_WALLET',
  INTERNET_BANKING = 'INTERNET_BANKING',
}
